import { useMutation } from "urql";

import { UpdateInvoiceDocument } from "../../../graphql/generated.ts";

export function useUpdateInvoice() {
  return useMutation(UpdateInvoiceDocument);
}
